export default __webpack_public_path__ + "static/media/IMG_0424-2.e7c5a276.jpg";